import React from 'react';
import './AboutMe.css';
import profilePicture from '../../../pic/avatar_me.png';
import { useTranslation } from 'react-i18next';



const AboutMe = () => {
    const { t } = useTranslation();
    return (
        <div className='about-me-container'>
            <div className="about-me-section">
                <div className="about-me-content">
                    <div className="about-me-title">
                        <h2>{t('aboutMe.title')}</h2>
                    </div>
                    <div className="about-me-description">
                        <p>{t('aboutMe.description')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutMe;